/**
 * ADHD signposting options for the triage decision wizard (RMS-309 model).
 *
 * BTH's confirmed list: the "Options4CYP further help" document (Mandy
 * Atkinson, confirmed 10 August 2026 with no additions for now - TDI-230),
 * transcribed 16 October 2026, followed by the "Links to signposting"
 * document's services (transcribed 2 November 2026, TDI-385). The clinician ticks the services to signpost;
 * each ticked option injects a heading plus the document's own description
 * into the outcome letter's signposting section, assembled server-side.
 * "Other, tell us more" carries a clinician-written title and text.
 *
 * The ids and labels mirror the backend's authoritative list in
 * python-functions/constants/rms_signposting_options.py - the server rejects
 * unknown ids and always writes its own label and paragraph, and a parity
 * test pins the two lists to each other.
 */
export const ADHD_SIGNPOSTING_OPTIONS = [
  { optionId: 'options4cyp_spoa', label: 'Options4CYP Single Point of Access' },
  { optionId: 'camhs', label: 'CAMHS' },
  { optionId: 'camhs_duty_team', label: 'CAMHS Duty Team' },
  { optionId: 'blackpool_rais', label: 'Blackpool RAIS (formerly CASHER)' },
  { optionId: 'initial_response_service', label: 'Initial Response Service (IRS)' },
  { optionId: 'youtherapy', label: 'YoutherapY' },
  { optionId: 'cyp_pmhs', label: "Children and Young People's Primary Mental Health Service (CYP PMHS)" },
  { optionId: 'childrens_social_care', label: "Children's Social Care" },
  { optionId: 'emergency_services', label: 'Emergency services' },
  { optionId: 'barnardos_thrive', label: "Barnardo's Thrive" },
  { optionId: 'fyi_directory', label: 'FYI Directory' },
  { optionId: 'self_help_resources', label: 'Self-help resources' },
  { optionId: 'options4cyp_self_referral', label: 'Options4CYP self-referral' },
  { optionId: 'pmhw_information', label: 'Primary Mental Health Workers' },
  { optionId: 'cywp', label: "Children's and Young People's Wellbeing Practitioners (CYWP)" },
  { optionId: 'shine_mhst', label: 'SHINE Mental Health Support Teams' },
  { optionId: 'childrens_psychology_service', label: "Children's Psychology Service" },
  { optionId: 'managing_challenging_behaviour', label: 'Carers Centre: Managing Challenging Behaviour course' },
  { optionId: 'triple_p', label: 'Triple P' },
  { optionId: 'first_hand_engagement', label: 'First Hand Engagement course' },
  { optionId: 'barnardos_parents', label: "Barnardo's: mental health support for parents and carers" },
  { optionId: 'the_den', label: 'The Den' },
  { optionId: 'counselling_in_the_community', label: 'Counselling in the Community' },
  { optionId: 'boathouse', label: 'Boathouse' },
  { optionId: 'aiming_higher', label: 'Aiming Higher' },
  { optionId: 'sendiass', label: 'SENDIASS' },
  { optionId: 'winstons_wish', label: "Winston's Wish" },
  { optionId: 'birchall_trust', label: 'Birchall Trust' },
  { optionId: 'cygnet', label: 'Cygnet' },
  { optionId: 'blackpool_talking_therapies', label: 'Blackpool Talking Therapies' },
  { optionId: 'adhd_north_west', label: 'ADHD North West' },
  { optionId: 'pairs', label: 'PAiRS' },
];

export const ADHD_SIGNPOSTING_PROMPT =
  'Which services should the family be signposted to?';

export const ADHD_SIGNPOSTING_HINT =
  'Optional - applies whether or not the referral was accepted. Each selected '
  + "service appears in the outcome letter with the service's own description.";
